































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {QingApp} from '../../entity/QingApp';
import {QingAppDto} from '../../dto/QingAppDto';
import QingAppForm from './QingAppFormE.vue';
import {Pagination} from 'pansx-utils';
import {Page} from 'pansx-utils';
import {QTableRequestOption} from 'pansx-utils';
import {SecurityUtils} from '@/oauth/SecurityUtils';

@Component({
  components: {QingAppForm},
})
export default class QingAppTable extends Vue {
  public data: QingApp[] = [];
  @Prop({default: () => new Pagination()})
  public readonly pagination!: Pagination;
  public qingAppFormDialog = false;
  public QingAppForm = new QingApp();
  @Prop({default: () => new QingApp()})
  public readonly filter!: QingApp;
  public loading = false;

  public get columns() {
    const columns = QingApp.getColumns();
    columns.push({
      label: '编辑',
      name: 'edit',
      field: '',
    });
    return columns;
  }

  public async getAll(q?: QTableRequestOption) {
    this.loading = true;

    try {
      if (typeof q !== 'undefined') {
        this.applyPagination(q.pagination);
      }
      const page = await QingAppDto.allPage(this.filter, this.pagination);
      const pg: Pagination = Page.of(page).getPagination();
      if (typeof q !== 'undefined') {
        pg.sortBy = q.pagination.sortBy;
        pg.descending = q.pagination.descending;
      }
      this.applyPagination(pg);
      this.data = page.content;
    } catch (e) {
      this.$q.notify({message: '错误:' + e, color: 'red'});
    } finally {
      this.loading = false;
    }
  }

  private applyPagination(q: Pagination | undefined) {
    if (typeof q !== 'undefined') {
      this.pagination.descending = q.descending;
      this.pagination.page = q.page;
      this.pagination.rowsNumber = q.rowsNumber;
      this.pagination.rowsPerPage = q.rowsPerPage;
      this.pagination.sortBy = q.sortBy;
    }
  }

  async save(d: QingApp) {
    try {
      await QingAppDto.save(d);
      this.$q.notify('保存成功!');
    } catch (e) {
      this.$q.notify({message: '错误:' + e, color: 'red'});
    }
  }

  public editQingApp(qingApp: QingApp) {
    this.QingAppForm = QingApp.of(qingApp);
    this.qingAppFormDialog = true;
  }

  public handleQingAppFormSubmit() {
    this.QingAppForm = new QingApp();
    this.qingAppFormDialog = false;
    this.getAll();
  }

  public async addQingApp() {
    this.QingAppForm = new QingApp();
    this.qingAppFormDialog = true;
  }

  public async deleteQingApp(qingApp: QingApp) {
    try {
      const id = qingApp.id;
      if (typeof id !== 'undefined') {
        await new Promise((resolve, reject) => {
          this.$q
              .dialog({
                cancel: true,
                message: '真的要删除吗?',
                persistent: true,
              })
              .onOk(async () => {
                await QingAppDto.delete(id);
                resolve(true);
              })
              .onCancel(reject);
        });
      }
      this.$q.notify({message: '删除成功', color: 'green'});
      await this.getAll();
    } catch (e) {
      this.$q.notify({message: '删除失败', color: 'red'});
    }
  }

  public mounted() {
    if (SecurityUtils.getTokenAuthorities().some(value => value === 'ADMIN')) {
      this.getAll();
    } else {
      this.$q.notify('你没有权限使用此功能');
      this.$router.replace('/');
    }
  }
}
